import { ConfigProvider } from 'antd';
import defaultSettings from '../../config/defaultSettings';
import { history } from 'umi';

const updateColorWeak = (colorWeak) => {
  const root = document.getElementById('root');

  if (root) {
    root.className = colorWeak ? 'colorWeak' : '';
  }
};

const SettingModel = {
  namespace: 'settings',
  state: defaultSettings,
  effects: {
    *updatePortal(__, { select }) {
      try {
        const { portal, settings } = yield select((state) => {
          return {
            portal: state.companyPortal.portal || history.location?.state,
            settings: state.settings,
          };
        });

        ConfigProvider.config({
          theme: {
            primaryColor: portal ? portal.mainColor : settings.primaryColor,
          },
        });
      } catch (e) {}
    },
  },
  reducers: {
    changeSetting(state = defaultSettings, { payload }) {
      const { colorWeak, contentWidth } = payload;

      if (state.contentWidth !== contentWidth && window.dispatchEvent) {
        window.dispatchEvent(new Event('resize'));
      }

      updateColorWeak(!!colorWeak);
      return { ...state, ...payload };
    },
  },
};
export default SettingModel;
